import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcListComponent, ExcListConfig} from 'exc-controls';
import {ExcRestService} from 'exc-rest';
import {ModalGeofenceAddComponentComponent} from '../modals/modal-geofence-add-component/modal-geofence-add-component.component';
import {ExcMapComponent} from 'exc-map';
import {forkJoin} from 'rxjs';

@Component({
  selector: 'app-geofence',
  templateUrl: './geofence.component.html',
  styles: []
})
export class GeofenceComponent extends ExcTranslation implements OnInit  {
  @ViewChild('mapInstance') mapContainer: any;
  @ViewChild('gfList') gfList: ExcListComponent;
  @ViewChild('map') map: any;
  mapObj: ExcMapComponent;
  mapData = {Markers: [], Geofence: null, IsEditMode: false, Geofences: [], ObjectIsDirty: false, IsAddMode : false, IsAddValid: false, SelectedAddType: null};
  selected = {Geofence: null, Location: null, Inventory: {}};
  geofenceListConfig: ExcListConfig = new ExcListConfig();
  allData = { Geofence: []};
  Data: {Header: any, Locations: any[]};
  dealerID;
  dealerName;
  searchValue = '';
  lastZoom = 15;
  bounds = null;
  sidebarExpanded = true;
  geofence: {
     gfName: string,
     gfColor:  string,
     gfType: string,
     gfBehaviour:  string,
     gfNote: string,
     gfData: string
  };
  firstSelect = true;
  polyShape: any;
  isGeofenceInsert = false;
  polygon: {
  gfName: string,
  gfColor:  string,
  gfType: string,
  gfBehaviour:  string,
  gfNote: string,
  gfData: string
  };
  drawingManager: any;
  isFirstLoad = true;
  addressText = false;
  input;
  selectedItems: [];
  markers = [];
  latlang:  google.maps.LatLng[] = [];

  constructor( private excRest: ExcRestService, private cdr: ChangeDetectorRef) {
    super();
    const _self = this;
    _self.geofenceListConfig.selectionMode = 'single';
    _self.geofenceListConfig.selectFirstAfterInit = true;
    _self.geofenceListConfig.OnSearch = function (searchValue, event?) {
      _self.searchValue = searchValue || '';
      _self.initialLoad ();
    };
    _self.geofenceListConfig.OnFocus = (selectedItems, event?) => {
      if (_self.selected.Geofence !== null) {
        _self.setDrawOptions(_self.selected.Geofence, false);
      }
      _self.selectGeofence([selectedItems]);
    };
    _self.geofenceListConfig.OnSelectionChanged = (selectedItems, event?) => {
      if (_self.selected.Geofence !== null) {
        _self.setDrawOptions(_self.selected.Geofence, false);
      }
      _self.selectGeofence(selectedItems);
    };
    _self.geofenceListConfig.MetaInfo.dataSort['gfLCD'] = 'Desc';
    // _self.geofenceListConfig.OnAdd = (event?) => {
    //   _self.openAddGeofenceModal(null);
    // };
    _self.geofenceListConfig.OnDelete = (selectedItems) => {
      _self.deleteGeofence(selectedItems);
    };
    _self.geofenceListConfig.OnRefresh = (event?) => {
      _self.initialLoad();
    };
  }
  selectGeofence(selectedItems: any[]) {
    const _self = this;
    if (_self.selected.Geofence !== undefined ) {
      if (_self.selected.Geofence !== null && _self.selected.Geofence.GeofenceObject !== null && _self.selected.Geofence.GeofenceObject !== undefined && selectedItems.length > 0 &&  _self.selected.Geofence.gfID !== selectedItems[0].gfID) {
        _self.selected.Geofence.GeofenceObject.setEditable(false);
        _self.selected.Geofence.GeofenceObject.setDraggable(false);
        _self.mapData.IsEditMode = false;
      }
      _self.selected.Geofence = selectedItems[0];
      if (_self.selected.Geofence) {
        _self.setDrawOptions(_self.selected.Geofence, true);
        if (_self.selected.Geofence.GeofenceObject && _self.firstSelect === false) {
          if (_self.selected.Geofence.gfType === 'POLY') {
            const paths = JSON.parse(_self.selected.Geofence.gfData);
            _self.mapContainer.map.setCenter(_self.getCenterOfPolygon(paths.coords));
          } else {
            _self.mapContainer.map.setCenter(_self.selected.Geofence.GeofenceObject.getBounds().getCenter());
          }
        }
        if (_self.mapData.IsEditMode) {
          _self.selected.Geofence.GeofenceObject.setEditable(true);
          _self.selected.Geofence.GeofenceObject.setDraggable(true);
        }
      }
      _self.firstSelect = false;
    }
  }
  ngOnInit() {
    const _self = this;
    _self.isFirstLoad = true;
    _self.dealerID = _self.Data.Header.DealerID;
    _self.dealerName = _self.Data.Header.DealerName;
    _self.initialLoad ();
  }

  initialLoad () {
    const _self = this;
    _self.allData.Geofence = [];
    const url = _self.excRest.computeUrl('DealerGeofenceR_List', {DealerID: _self.Data.Header.DealerID, tfs: _self.searchValue});
    const mi = _self.geofenceListConfig.GetMetaInfo();
    _self.geofenceListConfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.allData.Geofence = ret.data;
        _self.geofenceListConfig.paging = ret.paging;
      }
      _self.initMap();
      _self.geofenceListConfig.isLoading = false;

    });
  }
  reloadGeofences () {
    const _self = this;
  }
  centerMain() {
    this.mapContainer.map.fitBounds(this.bounds);
    // this.mapContainer.map.setCenter(new google.maps.LatLng(this.Data.Header.DealerLatitude, this.Data.Header.DealerLongitude));
    this.mapContainer.map.setZoom(this.lastZoom);
  }

  addGeofence() {
    if (this.mapData.IsAddMode === false && this.mapData.IsEditMode === false) {
      this.initDrawMode();
    }
  }
  selectAddMode(mode: string) {
    const _self = this;
    if (_self.drawingManager !== undefined && _self.drawingManager !== null) {

      if (_self.mapData.SelectedAddType === null) {
        if (mode === 'CIRCLE' || mode === 'POLY') {
          _self.mapData.SelectedAddType = mode;
        }
      }
      if (mode === 'MOVE') {
        _self.drawingManager.setDrawingMode(null);
      } else {
        if (_self.mapData.SelectedAddType === 'POLY') {
          _self.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
        } else {
          _self.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.CIRCLE);
        }
      }
    }
  }
  acceptNewGeofence() {
    const _self = this;
    const gfData = {gfName: null,
      gfType: null,
      gfBehaviour: null,
      gfNote: null,
      gfColor: null,
      gfData: null};
    switch (_self.polyShape.type) {
      case 'circle':
        gfData.gfType = 'CIRCLE';
        gfData.gfData = JSON.stringify({
          center: {lat: _self.polyShape.getCenter().lat(), lng: _self.polyShape.getCenter().lng()},
          radius: _self.polyShape.getRadius()
        });
        break;
      case 'rectangle':
        gfData.gfType = 'RECT';
        gfData.gfData = JSON.stringify({bounds: {
            NorthEast: {
              lat:  _self.polyShape.getBounds().getNorthEast().lat(),
              lng:  _self.polyShape.getBounds().getNorthEast().lng()
            },
            SouthWest: {
              lat:  _self.polyShape.getBounds().getSouthWest().lat(),
              lng:  _self.polyShape.getBounds().getSouthWest().lng()
            }
          }});
        break;
      case 'polygon':
        gfData.gfType = 'POLY';
        const polygonBounds = _self.polyShape.getPath();
        let bounds = [];
        bounds = [];
        for (let i = 0; i < polygonBounds.length; i++) {
          const point = {
            lat: polygonBounds.getAt(i).lat(),
            lng: polygonBounds.getAt(i).lng()
          };
          bounds.push(point);
        }
        gfData.gfData = JSON.stringify({ coords: bounds} );
        break;
    }
    _self.endDrawMode();
    _self.showCreateModal(gfData);
  }
  discardNewGeofence() {
    const _self = this;
    _self.mapData.IsAddMode = false;
    _self.mapData.IsAddValid = false;
    _self.mapData.IsEditMode = false;
    _self.isGeofenceInsert = false;

    _self.endDrawMode();
    _self.cleanDrawShape();
  }
  initDrawMode() {
    const _self = this;
    _self.isGeofenceInsert = true;
    _self.mapData.IsEditMode = false;
    _self.mapData.IsAddMode = true;
    _self.mapData.IsAddValid = false;
    if (_self.selected.Geofence) {
      if (_self.selected.Geofence.GeofenceObject !== null) {
        _self.selected.Geofence.GeofenceObject.setEditable(false);
        _self.selected.Geofence.GeofenceObject.setDraggable(false);
        _self.setDrawOptions(_self.selected.Geofence, false);
      }
    }
    _self.drawingManager = new google.maps.drawing.DrawingManager({
      drawingMode:  null,
      drawingControl: false,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: [
          google.maps.drawing.OverlayType.POLYGON
          , google.maps.drawing.OverlayType.CIRCLE
        ]
      },
      circleOptions: {
        fillColor: '#000000',
        strokeColor:  '#000000',
        fillOpacity: 0.45,
        strokeWeight: 4,
        clickable: false,
        editable: true,
        zIndex: 1
      },
      polygonOptions: {
        strokeWeight: 4,
        fillOpacity: 0.45,
        fillColor: '#000000',
        strokeColor:  '#000000',
        editable: true,
        zIndex: 1
      }
    });
    _self.drawingManager.setMap(this.mapContainer.map);
    google.maps.event.addListener(_self.drawingManager, 'overlaycomplete', function (event) {
      if (event.type !== google.maps.drawing.OverlayType.MARKER) {
        _self.polyShape = event.overlay;
        _self.polyShape.type = event.type;
        google.maps.event.addListener( _self.polyShape, 'click', function () {
          _self.polyShape = null;
        });
        _self.mapData.IsAddValid = true;
        _self.endDrawMode();
      }
    });
  }
  showCreateModal(geofenceData) {
    const _self = this;
    ExcCoreModule.showModal(ModalGeofenceAddComponentComponent, null, 'm', {data: _self.geofence}, false, null).subscribe(ret => {
      _self.cleanDrawShape();
      _self.mapData.IsEditMode = false;
      _self.mapData.IsAddMode = false;
      _self.mapData.IsAddValid = false;
      if (ret && ret.proceed === true) {
        geofenceData.gfBehaviour = ret.geofence.gfBehaviour;
        geofenceData.gfName = ret.geofence.gfName;
        geofenceData.gfColor = ret.geofence.gfColor;
        geofenceData.gfBehaviour = ret.geofence.gfBehaviour;
        geofenceData.gfNote = ret.geofence.gfNote;

        _self.geofenceListConfig.isLoading = true;
        const url = _self.excRest.computeUrl('DealerGeofenceC', {DealerID: _self.dealerID});
        _self.excRest.put(url, geofenceData, {}).subscribe(rest => {
          _self.allData.Geofence.splice(0, 0, rest.data[0]);
          _self.drawSingleGeofence(_self.allData.Geofence[0]);
          _self.selectGeofence([_self.allData.Geofence[0]]);
          _self.isGeofenceInsert = false;
          _self.geofenceListConfig.isLoading = false;
        });
      } else {
       _self.discardNewGeofence();
      }
    });
  }
  cleanDrawShape() {
    const _self = this;
    if (_self.polyShape !== null) {
      _self.polyShape.setMap(null);
      _self.polyShape = null;
    }
    _self.mapData.SelectedAddType = null;
  }
  endDrawMode() {
    const _self = this;
    if (_self.drawingManager !== null) {
      _self.drawingManager.setDrawingMode(null);
      _self.drawingManager.setOptions({
        drawingControl: false
      });
      _self.drawingManager.setMap(null);
      _self.drawingManager = null;
    }
  }

  deleteGeofence(selectedItems) {
    const _self = this;
    if (selectedItems.length > 0 ) {
       const requests = [];
      _self.clearMap();
      const calls = [];
      for (const inv of selectedItems) {
        const url = _self.excRest.computeUrl('DealerGeofenceD', {DealerID: _self.dealerID,  gfID: inv.gfID });
        calls.push(_self.excRest._deleteInternal(url, { DealerID: _self.dealerID, gfID: inv.gfID
        }, {}, true));
      }
      forkJoin(calls).subscribe(stack => {
        _self.selected.Geofence = null;
        _self.initialLoad();
      });
    }
  }
  setObjectDirty() {
    // this.mapData.ObjectIsDirty = true;
    // this.cdr.detectChanges();
  }
  drawSingleGeofence(fence, isSelected = false) {
    if (fence === undefined || fence === null) {
      return;
    }
    const _self = this;
    let color = '';
    const gfParams = JSON.parse(fence.gfData);
    switch (fence.gfColor) {
      case 'RED':
        color = '#ff0000';
        break;
      case 'BLUE':
        color = '#0000ff';
        break;
      case 'GREEN':
        color = '#00ff00';
        break;
      case 'YELLOW':
        color = '#fffc00';
        break;
      case 'BLACK':
        color = '#000000';
        break;
    }
    let opts = null;
    switch (fence.gfType) {
      case 'CIRCLE':
        const center = new google.maps.LatLng(gfParams['center']['lat'], gfParams['center']['lng']);
        opts = _self.getDrawOption(color, isSelected);
        opts['center'] = center;
        opts['radius'] = gfParams['radius'];
        fence['GeofenceObject'] = new google.maps.Circle(opts);
        fence['GeofenceObject'].addListener('radius_changed', () => {_self.setObjectDirty(); });
        fence['GeofenceObject'].addListener('dragend', () => {_self.setObjectDirty(); });
        fence['GeofenceObject'].addListener('center_changed', () => {_self.setObjectDirty(); });

        _self.mapData.Geofences.push(fence['GeofenceObject']);
        break;
      case 'RECT':
        const ne = new google.maps.LatLng(gfParams['bounds']['NorthEast']);
        const sw = new google.maps.LatLng(gfParams['bounds']['SouthWest']);
        const b = new google.maps.LatLngBounds(sw, ne);
        opts = _self.getDrawOption(color, isSelected);
        opts['bounds'] = b;
        fence['GeofenceObject'] = new google.maps.Rectangle(opts);
        // fence['GeofenceObject'].bounds_changed = () => {_self.setObjectDirty(); };
        // fence['GeofenceObject'].dragend = () => {_self.setObjectDirty(); };

        _self.mapData.Geofences.push(fence['GeofenceObject']);
        break;
      case 'POLY':
        opts = _self.getDrawOption(color, isSelected);
        opts['paths'] = gfParams['coords'];
        const poly = new google.maps.Polygon(opts);
        // poly.addListener('dragend', () => {_self.setObjectDirty(); });
        // poly.addListener('insert_at', () => {_self.setObjectDirty(); });
        // poly.addListener('remove_at', () => {_self.setObjectDirty(); });
        // poly.addListener('set_at', () => {_self.setObjectDirty(); });
        fence['GeofenceObject'] = poly;
        _self.mapData.Geofences.push(fence['GeofenceObject']);
        break;
    }
    if ( fence['GeofenceObject'] !== undefined) {
      fence['GeofenceObject'].addListener('click', () => {
        // setTimeout(() => {
          fence.isSelected = true;
          _self.gfList.focusItem(fence);
          _self.gfList.toggleSelect(fence);
          _self.selected.Geofence = fence;
          _self.cdr.markForCheck();
          _self.cdr.detectChanges();
        // }, 50);
      });
    }
  }
  test() {
    this.gfList.focusItem(this.allData.Geofence[0]);
    // this.gfList.toggleSelect(this.allData.Geofence[0]);
    // this.selected.Geofence = this.allData.Geofence[0];
    // this.cdr.markForCheck();
    // this.cdr.detectChanges();
  }
  getDrawOption(color: string, isSelected = false) {
    return {
      editable: false, draggable: false,
      strokeColor: color,
      strokeOpacity: isSelected ? 0.9 : 0.6,
      strokeWeight: isSelected ? 3 : 2,
       fillColor: color,
       fillOpacity: isSelected ? 0.4 : 0,
      map: this.mapContainer.map,
    };
  }
  setDrawOptions(fence, isSelected = false) {
    if (fence === undefined || fence === null || fence['GeofenceObject'] === undefined || fence['GeofenceObject'] === null) {
      return;
    }
    const _self = this;
    let color = '';
    const gfParams = JSON.parse(fence.gfData);
    /// _self.mapContainer.map.setZoom(15);
    switch (fence.gfColor) {
      case 'RED':
        color = '#ff0000';
        break;
      case 'BLUE':
        color = '#0000ff';
        break;
      case 'GREEN':
        color = '#00ff00';
        break;
      case 'YELLOW':
        color = '#fffc00';
        break;
      case 'BLACK':
        color = '#000000';
        break;
    }
    let opts = null;
    switch (fence.gfType) {
      case 'CIRCLE':
        const center = new google.maps.LatLng(gfParams['center']['lat'], gfParams['center']['lng']);
        opts = _self.getDrawOption(color, isSelected);
        opts['center'] = center;
        opts['radius'] = gfParams['radius'];
        fence['GeofenceObject'].setOptions(opts);
        break;
      case 'RECT':
        const ne = new google.maps.LatLng(gfParams['bounds']['NorthEast']);
        const sw = new google.maps.LatLng(gfParams['bounds']['SouthWest']);
        const b = new google.maps.LatLngBounds(sw, ne);
        opts = _self.getDrawOption(color, isSelected);
        opts['bounds'] = b;
        fence['GeofenceObject'].setOptions(opts);
        break;
      case 'POLY':
        opts = _self.getDrawOption(color, isSelected);
        opts['paths'] = gfParams['coords'];
       fence['GeofenceObject'].setOptions(opts);
        break;
    }
  }
  getGeofenceAvatar(data) {
    const cls = [];
    switch (data.gfType) {
      case 'POLY': cls.push('fa-draw-polygon'); break;
      case 'RECT': cls.push('fa-square'); break;
      case 'CIRCLE': cls.push('fa-circle'); break;
    }
    switch (data.gfColor) {
      case 'RED': cls.push('th-danger'); break;
      case 'GREEN': cls.push('th-success'); break;
      case 'BLUE': cls.push('th-secondary'); break;
      case 'YELLOW': cls.push('th-primary'); break;

    }
    return cls;
  }
  restoreGeofence() {
    const _self = this;
    if (_self.isGeofenceInsert === true) {
      return;
    }
    _self.setGeofeonceEdit(false);
    _self.isGeofenceInsert = false;

    if (_self.polyShape !== undefined && _self.polyShape !== null) {
      _self.polyShape.setMap(null);
      _self.polyShape = null;
    }
    if (_self.drawingManager !== undefined && _self.drawingManager !== null) {
      _self.drawingManager.drawingControl = false;
      _self.drawingManager.setMap(_self.mapContainer.map);
    }
    _self.selected.Geofence.GeofenceObject.setMap(null);
    delete _self.selected.Geofence.GeofenceObject;
    _self.drawSingleGeofence(this.selected.Geofence);
    _self.setDrawOptions(_self.selected.Geofence, true);
  }
  clearMap() {
    for (const x of this.mapData.Markers) {
      x.setMap(null);
    }
    if (this.mapData.Geofence !== null) {
      this.mapData.Geofence.setMap(null);
      this.mapData.Geofence = null;
    }
    for (const x of this.mapData.Geofences) {
      x.setMap(null);
    }
    this.mapData.Geofences = [];
    this.mapData.Markers = [];
  }
  setGeofeonceEdit(isEdit, data?: any ) {
    const _self = this;
    _self.mapData.IsEditMode = isEdit;

    if (isEdit && _self.selected.Geofence !== null) {
      if (_self.selected.Geofence) {
        if (_self.selected.Geofence.GeofenceObject !== null) {
          _self.selected.Geofence.GeofenceObject.setEditable(false);
          _self.selected.Geofence.GeofenceObject.setDraggable(false);
          _self.setDrawOptions(_self.selected.Geofence, false);
        }
      }
    }

    if (data !== undefined && data !== null) {
      _self.selected.Geofence = data;
      _self.gfList.toggleSelect(_self.selected.Geofence);
    }

    if (isEdit === true && !_self.isGeofenceInsert) {
      if (_self.selected.Geofence) {
        if (_self.selected.Geofence.GeofenceObject !== null) {
          _self.selected.Geofence.GeofenceObject.setEditable(isEdit);
          _self.selected.Geofence.GeofenceObject.setDraggable(isEdit);
        }
      }
    }
  }
  saveGeofence() {
    const _self = this;
    if (_self.isGeofenceInsert) {
      if (_self.polyShape) {
        _self.saveGeofenceData(_self.polygon);
      }
    } else {
      const url = _self.excRest.computeUrl('DealerGeofenceU', {DealerID: _self.dealerID, gfID: _self.selected.Geofence.gfID});
      let gfData = {};
      switch (_self.selected.Geofence.gfType) {
        case 'CIRCLE':
          gfData = {
            center: {lat: _self.selected.Geofence.GeofenceObject.getCenter().lat(), lng: _self.selected.Geofence.GeofenceObject.getCenter().lng()},
            radius: _self.selected.Geofence.GeofenceObject.getRadius()
          };
          break;
        case 'RECT':
          gfData = {bounds: {
              NorthEast: {
                lat: _self.selected.Geofence.GeofenceObject.getBounds().getNorthEast().lat(),
                lng: _self.selected.Geofence.GeofenceObject.getBounds().getNorthEast().lng()
              },
              SouthWest: {
                lat: _self.selected.Geofence.GeofenceObject.getBounds().getSouthWest().lat(),
                lng: _self.selected.Geofence.GeofenceObject.getBounds().getSouthWest().lng()
              }
            }};
          break;
        case 'POLY':
          const polygonBounds = _self.selected.Geofence.GeofenceObject.getPath();
          let bounds = [];
          bounds = [];
          for (let i = 0; i < polygonBounds.length; i++) {
            const point = {
              lat: polygonBounds.getAt(i).lat(),
              lng: polygonBounds.getAt(i).lng()
            };
            bounds.push(point);
          }
          gfData = { coords: bounds} ;
          break;
      }
      _self.excRest.post(url, {gfData: JSON.stringify(gfData)}, {}).subscribe(rest => {
        Object.assign(_self.selected.Geofence, rest.data[0]);
        _self.selected.Geofence.GeofenceObject.setEditable(false);
        _self.selected.Geofence.GeofenceObject.setDraggable(false);
        // _self.drawGeofence();
        _self.mapData.IsEditMode = false;
      });
    }
  }
  // this function adds new map markers after a select menu change
  addNewMarkers() {
    const _self = this;
    const map = _self.mapContainer.map;
    let marker, i;
    for (const x of _self.allData.Geofence) {
      _self.drawSingleGeofence(x);
      if ( x.GeofenceObject !== undefined && x.GeofenceObject.gfType !== 'Polygon') {
        switch (x.gfType) {
          case 'CIRCLE':
            break;
          case 'POLY':
            let path: any[] = [];
            path = JSON.parse(x.gfData).coords;
            for ( i = 0; i < path.length; i++) {
              _self.latlang.push( new google.maps.LatLng(path[i].lat, path[i].lng));
            }
            break;
          case 'RECT':
            /* bnd.extend(x.GeofenceObject.getBounds().getNorthEast());
             bnd.extend(x.GeofenceObject.getBounds().getSouthWest());*/
            break;
        }
      }
    }
    if (_self.Data.Header.DealerLatitude !== null && _self.Data.Header.DealerLatitude !== 0) {
      marker = new google.maps.Marker({position: new google.maps.LatLng(_self.Data.Header.DealerLatitude, _self.Data.Header.DealerLongitude)
        , map: this.mapContainer.map, icon: { url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'}});
      marker.setClickable(true);
      const infowindow = new google.maps.InfoWindow({
        content: '<div id="content">' +
          '<div id="bodyContent">' +
          '<p><b style=\"font-weight: bold;\">' + _self.Data.Header.DealerName + '</b> <br />' + _self.Data.Header.DealerStreet +
          '<br  />' + _self.Data.Header.DealerCountry + '-' + _self.Data.Header.DealerZip + ' ' + _self.Data.Header.DealerCity + '</p>' +
          '</div></div>'
      });
      marker.addListener('click', () => {
        infowindow.open(map , marker);
      });
      _self.markers.push(marker);
      infowindow.open(map, marker);
      const latlangpoint = new google.maps.LatLng(_self.Data.Header.DealerLatitude, _self.Data.Header.DealerLongitude);
      _self.latlang.push(latlangpoint);
    }
    for ( i = 0; i < _self.Data.Locations.length; i++)  {
      if (_self.Data.Locations[i].LocationLatitude !== null && _self.Data.Locations[i].LocationLatitude !== 0) {
        const color = _self.Data.Locations[i]['LocationIsApproved'] === true ? 'green' : 'red';
        marker = new google.maps.Marker({position: new google.maps.LatLng(_self.Data.Locations[i].LocationLatitude, _self.Data.Locations[i].LocationLongitude)
          , map: this.mapContainer.map, icon: { url: 'http://maps.google.com/mapfiles/ms/icons/' + color + '-dot.png'}});
        marker.setClickable(true);
        const infowindow = new google.maps.InfoWindow({
          content: '<div id="content">' +
            '<div id="bodyContent">' +
            '<p><b style=\"font-weight: bold;\">' + _self.Data.Locations[i]['LocationName'] + '</b> <br />' + _self.Data.Locations[i]['LocationStreet'] + '<br  />' + _self.Data.Locations[i]['LocationCountry'] + '-' + _self.Data.Locations[i]['LocationZip'] + ' ' + _self.Data.Locations[i]['LocationCity'] + '</p>' +
            '</div></div>'});
        marker.addListener('click', () => {
          infowindow.open(map , marker);
        });
        _self.markers.push(marker);
        infowindow.open(map, marker);
        const latlangpoint = new google.maps.LatLng(_self.Data.Locations[i].LocationLatitude, _self.Data.Locations[i].LocationLongitude);
        _self.latlang.push(latlangpoint);
    }
    } // end of for loop
  } // end of addNewMarkers function
  initMap() {
    const _self = this;
    const map = _self.mapContainer.map;
    _self.clearMap();
    _self.bounds = new google.maps.LatLngBounds();
    _self.addNewMarkers();
    const bnd = new google.maps.LatLngBounds();
    for (let i = 0; i <  _self.latlang.length; i++) {
      bnd.extend(_self.latlang[i]);
    }
    setTimeout(() => {
    map.fitBounds(bnd);
    // if (map.getZoom() > 15) {
    //   map.setZoom(15);
    // }
    }, 100);
    _self.bounds = bnd;
    _self.lastZoom = map.getZoom();
    _self.input = document.getElementById('pac-input') as HTMLInputElement;
   const searchBox = new google.maps.places.SearchBox( _self.input );
    if (_self.isFirstLoad) {
    map.controls[google.maps.ControlPosition.LEFT_TOP].push( _self.input);
    }
    // Bias the SearchBox results towards current map's viewport.
    map.addListener('bounds_changed', () => {
      searchBox.setBounds(map.getBounds() as google.maps.LatLngBounds);
    });

    let markers: google.maps.Marker[] = [];
    // Listen for the event fired when the user selects a prediction and retrieve
    // more details for that place.

    searchBox.addListener('places_changed', () => {
      const places = searchBox.getPlaces();
      _self.addressText = true;
      if (places.length === 0) {
        _self.addressText = false;
        return;
      }

      // Clear out the old markers.
      markers.forEach((marker) => {
        marker.setMap(null);
      });
      markers = [];

      // For each place, get the icon, name and location.
      const bounds = new google.maps.LatLngBounds();
      places.forEach((place) => {
        if (!place.geometry || !place.geometry.location) {
          return;
        }
        const icon = {
          url: place.icon as string,
          size: new google.maps.Size(71, 71),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 34),
          scaledSize: new google.maps.Size(25, 25),
        };
        // Create a marker for each place.
        markers.push(
          new google.maps.Marker({
            map,
            icon,
            title: place.name,
            position: place.geometry.location,
          })
        );

        if (place.geometry.viewport) {
          // Only geocodes have viewport.
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
      });
      this.mapContainer.map.setCenter(places[0].geometry.location);

      // map.fitBounds(bounds);
    });
    _self.isFirstLoad = false;
  }
   getCenterOfPolygon(data: any[]) {
      const _self = this;
      let lowx, highx, lowy, highy;
      const  lats = [], lngs = [], vertices = data;
      for (let i = 0; i < vertices.length; i++) {
        lngs.push(vertices[i].lng);
        lats.push(vertices[i].lat);
      }
      lats.sort();
      lngs.sort();
      lowx = lats[0];
      highx = lats[vertices.length - 1];
      lowy = lngs[0];
      highy = lngs[vertices.length - 1];
      const center_x = lowx + ((highx - lowx) / 2);
      const center_y = lowy + ((highy - lowy) / 2);
      return (new google.maps.LatLng(center_x, center_y));
     }
  drawGeofenceShape() {
      const _self = this;
      const gMap =  google.maps;
      _self.drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode:  gMap.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
         position: gMap.ControlPosition.TOP_CENTER,
          drawingModes: [
              gMap.drawing.OverlayType.POLYGON
            , gMap.drawing.OverlayType.CIRCLE
          ]
        },
        circleOptions: {
          fillColor: _self.polygon.gfColor,
          strokeColor:  _self.polygon.gfColor,
          fillOpacity: 0.45,
          strokeWeight: 4,
          clickable: false,
          editable: true,
          zIndex: 1
        },
        polygonOptions: {
          strokeWeight: 4,
          fillOpacity: 0.45,
          fillColor: _self.polygon.gfColor,
          strokeColor:  _self.polygon.gfColor,
          editable: true,
          zIndex: 1
        }
      });
      _self.drawingManager.setMap(this.mapContainer.map);
      google.maps.event.addListener(_self.drawingManager, 'overlaycomplete', function (event) {
        if (event.type !== google.maps.drawing.OverlayType.MARKER) {
          _self.drawingManager.setDrawingMode(null);
          _self.polyShape = event.overlay;
          _self.polyShape.type = event.type;
          _self.drawingManager.setOptions({
            drawingControl: false
          });
          google.maps.event.addListener( _self.polyShape, 'click', function () {
            _self.polyShape = null;
          });
          switch (_self.polyShape.type) {
            case 'circle':
              _self.polygon.gfType = 'CIRCLE';
              break;
            case 'rectangle':
              _self.polygon.gfType = 'RECT';
              break;
            case 'polygon':
              _self.polygon.gfType = 'POLY';
              break;
          }
        }
      });
    }
  insertGeofence() {
      const _self = this;
      _self.isGeofenceInsert = true;
      _self.setGeofeonceEdit(true);
      _self.drawGeofenceShape();
    }
    saveGeofenceData(geofence) {
      const _self = this;
      let gfData = {};
      switch (_self.geofence.gfType) {
        case 'CIRCLE':
          gfData = {
            center: {lat: _self.polyShape.getCenter().lat(), lng: _self.polyShape.getCenter().lng()},
            radius: _self.polyShape.getRadius()
          };
          break;
        case 'RECT':
          gfData = {bounds: {
              NorthEast: {
                lat:  _self.polyShape.getBounds().getNorthEast().lat(),
                lng:  _self.polyShape.getBounds().getNorthEast().lng()
              },
              SouthWest: {
                lat:  _self.polyShape.getBounds().getSouthWest().lat(),
                lng:  _self.polyShape.getBounds().getSouthWest().lng()
              }
            }};
          break;
        case 'POLY':
          const polygonBounds = _self.polyShape.getPath();
          let bounds = [];
          bounds = [];
          for (let i = 0; i < polygonBounds.length; i++) {
            const point = {
              lat: polygonBounds.getAt(i).lat(),
              lng: polygonBounds.getAt(i).lng()
            };
            bounds.push(point);
          }
          gfData = { coords: bounds} ;
          break;
      }
        _self.geofenceListConfig.isLoading = true;
        const url = _self.excRest.computeUrl('DealerGeofenceC', {DealerID: _self.dealerID});
         _self.excRest.put(url, {
           gfName: geofence.gfName,
           gfType: geofence.gfType,
           gfBehaviour: geofence.gfBehaviour,
           gfNote: geofence.gfNote,
           gfColor: geofence.gfColor,
           gfData: JSON.stringify(gfData)
         }, {}).subscribe(rest => {
           _self.allData.Geofence.splice(0, 0, rest.data[0]);
           _self.drawSingleGeofence(_self.allData.Geofence[0]);
           _self.selectGeofence([_self.allData.Geofence[0]]) ;
           _self.isGeofenceInsert = false;
           _self.drawingManager.drawingControl = false;
           _self.polyShape.setMap(null);
           _self.polyShape = null;
           _self.drawingManager.setMap(_self.mapContainer.map);
           _self.geofenceListConfig.isLoading = false;
         });
    }
    getMainContainerStyle() {
    if (this.sidebarExpanded === true) {
      return {
        gridTemplateColumns: '4fr 1fr',
        gridTemplaterows: '1fr'
      };
    } else {
      return {
        gridTemplateColumns: '32fr 1fr',
        gridTemplaterows: '1fr'
      };
    }
  }
}
